import React from 'react';
import Poi from './Poi';
import Route from './Route';

import './style.css';

import * as tripHelper from '../../../../../helpers/trip';
import {isHotel} from '../../../../../helpers/poi';

export default function PoiList(props) {
  let {trip, day, route} = props;

  let pois = tripHelper.getPoisOfDayTrip(trip, day);
  // ui需要。需要补充两个占位符（PoiAdd: hotel, other）
  let uiPois = [...pois];
  // 插入占位符位置（-0, -1）
  let position = needAddPoiForDayTrip(pois, day, trip.trip_days);
  if (position !== false) {
    position = pois.length + position;
    uiPois.splice(position, 0, 'add-poi');
  }

  if (needAddHotelForDayTrip(pois, day, trip.trip_days)) {
    uiPois.push('add-hotel');
  }

  let routeIds = [];
  let listView = [];
  let key = ''; // Component key
  uiPois.forEach(function (poi, index) {
    let poi_uid = poi.poi_uid || poi;
    routeIds.push(poi_uid);

    if (index >= 1) {
      let routeKey = routeIds.join('-');
      key = `${day}-${index}-${routeKey}`;
      listView.push(
        <Route
          key={key}
          day={day}
          route={route ? route[routeKey] : undefined}
          trip={trip} />
      );

      routeIds.shift();
    }

    key = `${day}-${index}-${poi_uid}`;
    listView.push(
      <Poi key={key} uiPoi={poi} day={day} trip={trip} />
    );
  });

  return (
    <section className='poi-list'>
      <header>
        <h2>今天行程（{pois.length}个）</h2>
      </header>
      <main>{listView}</main>
    </section>
  );
}

// 返回插入数组的位置（倒数）
function needAddPoiForDayTrip(pois, day, trip_days) {
  let need = true;
  let lastPoi;
  pois.forEach(function (poi) {
    // 存在poi
    if (!(isHotel(poi) || poi.isPrev)) {
      need = false;
    }

    // 不包含前一天的poi
    if (!poi.isPrev) {
      lastPoi = poi;
    }
  });

  if (need) {
    // 存在最后一个poi，就将占位符放到倒数第二；否则倒数第一
    if (lastPoi) {
      return -1;
    } else {
      return -0;
    }
  }

  return false;
}


// 是否需要添加酒店
function needAddHotelForDayTrip(pois, day, trip_days) {
  if (day === trip_days) {
    return false;
  }

  let last = pois.length - 1;
  let poi = pois[last];

  // 最后一个是hotel且不是isPrev
  return !(poi && isHotel(poi) && !poi.isPrev);
}



// WEBPACK FOOTER //
// ./src/pages/trip/Trip/DayTrip/PoiList/index.js